/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesAddOnProduct = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesAddOnProduct = typeof WebApiModelsEnumerationTypesAddOnProduct[keyof typeof WebApiModelsEnumerationTypesAddOnProduct];


export function WebApiModelsEnumerationTypesAddOnProductFromJSON(json: any): WebApiModelsEnumerationTypesAddOnProduct {
    return WebApiModelsEnumerationTypesAddOnProductFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesAddOnProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesAddOnProduct {
    return json as WebApiModelsEnumerationTypesAddOnProduct;
}

export function WebApiModelsEnumerationTypesAddOnProductToJSON(value?: WebApiModelsEnumerationTypesAddOnProduct | null): any {
    return value as any;
}

